import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getWebViewHtml } from '../action/webViewContentAction.js';
import { hashHistory } from 'react-router';
import NavigatorMain from './NavigatorMain';


class PrivacyAgreement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title:"华夏财富用户隐私政策"
    };
  }
  componentWillMount(){
    document.title = this.state.title
    let {dispatch}=this.props;
    dispatch(getWebViewHtml({name:'华夏财富用户隐私政策',code:'pro_027'}, ()=>{this.succallback()}, (msg)=>{this.errcallback(msg)}));
  }
  succallback(){
    // alert()
  }
  errcallback(msg){
    // alert(msg)
  }
  render(){
    return (
      <div className="container" >
        <NavigatorMain>
          <div className="header black">
            <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
            <div>{this.state.title}</div>
            <div></div>
          </div>
        </NavigatorMain>
        <div className='content'>
          <div style={{fontSize:'0.36rem',padding:13}} dangerouslySetInnerHTML={{__html:
              this.props.webViewHtml
          }} />
        </div>
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  return {
    webViewHtml:state.webViewHtml
  }
}
export default connect(mapStateToProps)(PrivacyAgreement);




// WEBPACK FOOTER //
// ./src/components/PrivacyAgreement.js